document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-aura-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-slide]');
    var dots = hero.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;

    var current = 0;
    var seconds = parseInt(hero.dataset.autoplay || '5', 10);
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (reduceMotion || !seconds) return;
      stopAutoplay();
      timer = setInterval(next, seconds * 1000);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    var nextBtn = hero.querySelector('[data-next]');
    var prevBtn = hero.querySelector('[data-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});